import { BrandGradientDefs, type IllustrationProps, Sparkle } from "./common";

export function EmptyNotifications({ size = 120, ...props }: IllustrationProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 200 200"
      width={size}
      height={size}
      fill="none"
      aria-hidden
      {...props}
    >
      <BrandGradientDefs id="en" />
      {/* Bell body */}
      <path
        d="M 60 70 Q 60 50 80 50 L 120 50 Q 140 50 140 70 L 140 120 L 154 134 L 46 134 L 60 120 Z"
        fill="hsl(var(--background))"
        stroke="url(#en-stroke)"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <ellipse cx="100" cy="146" rx="12" ry="6" fill="url(#en-stroke)" opacity="0.85" />
      {/* Bell top knob */}
      <rect x="92" y="40" width="16" height="10" rx="3" fill="url(#en-stroke)" />
      {/* Inner gradient */}
      <path
        d="M 70 76 Q 70 60 84 60 L 116 60 Q 130 60 130 76 L 130 116 L 70 116 Z"
        fill="url(#en-fill)"
      />

      {/* Zzz */}
      <text
        x="148"
        y="62"
        fontFamily="ui-rounded, system-ui, sans-serif"
        fontSize="14"
        fontWeight="700"
        fill="url(#en-stroke)"
        opacity="0.7"
      >
        z
      </text>
      <text
        x="160"
        y="50"
        fontFamily="ui-rounded, system-ui, sans-serif"
        fontSize="11"
        fontWeight="700"
        fill="url(#en-stroke)"
        opacity="0.5"
      >
        z
      </text>

      <Sparkle cx={32} cy={48} size={7} opacity={0.6} />
    </svg>
  );
}
